import { createContext, useContext, useState } from "react";

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const loggedInUserId = localStorage.getItem("userId");

  const [sharedData, setSharedData] = useState({
    userId: loggedInUserId ? Number(loggedInUserId) : null, // Ensure it's a number
    isEditMode: false,
    userIdFromUrl: null,
    code: null,
  });

  return (
    <FormContext.Provider value={{ sharedData, setSharedData }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => useContext(FormContext);
